export default __webpack_public_path__ + "static/media/handofdoom.36506c58.png";